import { gql } from '@apollo/client';

export const GET_USER_ID_BY_AUTH_ID = gql`
  query GetUserIdByAuthId($authId: String!) {
    userIdByAuthId(authId: $authId)
  }
`;

export interface GetUserIdByAuthIdResult {
  userIdByAuthId: number | null;
}
